<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            slab: {
                required: true,
            },
            frameMaterial: {
                required: false,
                default(){
                    return '1';
                }
            },
            doorRange: {
                required: false,
                default() {
                    return 0;
                }
            },
            colourRange: {
                required: false,
                default() {
                    return 0;
                }
            },
            slabCassette: {
              required: false,
              default() {
                return 0;
              }
            },
            title: {
                default(){
                    return null;
                }
            }
        },
        computed: {
            thumbURL(){
                return '/thumb/door-colour-' + this.frameMaterial + '/';
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.doorRange, this.colourRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/door-colour-external?slab=' + this.slab + '&door_range=' + this.doorRange + '&colour_range=' + this.colourRange + '&frame_material=' + this.frameMaterial + '&slab_cassette=' + this.slabCassette;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.slab + '_' + this.doorRange + '_' + this.colourRange + '_' + this.frameMaterial + '_' + this.slabCassette;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
              this.update_options();
            },
            'target': function (val, oldVal) {
                window.emitter.emit('door-external-colour-updated', val);
            }
        },
    }
</script>
